export default "<advertisements #ads [transitionDelay]=\"transitionDelay\"\n    [zoom]=\"zoom\"\n    [advertisements]=\"advertisements\">\n</advertisements>";